var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"formRef",staticClass:"form-seplag p-grid p-fluid"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }